// extracted by mini-css-extract-plugin
export default {"info":"TechnicalPoints-info__9Lp5"};